import styled from '@emotion/styled';
import { Chip, Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';

type Props = {
  count: number;
  className?: string;
};

const CreativeFormatCount: FC<Props> = ({ count, className }) => {
  return (
    <Root className={className}>
      <Chip
        label={
          <Typography variant="body2" color="inherit">
            <FormattedMessage id="project_editing_page.basic_setting.creative_formats.count_label" />: {count}
          </Typography>
        }
        color="default"
      />
    </Root>
  );
};

const Root = styled('div')(
  flexibleLayoutContainer({
    justifyContent: 'flex-end',
  }),
);

export default CreativeFormatCount;
